<mat-tab-group>
    <mat-tab label="Details">
        <form [formGroup]="detailsForm">
            <div class="tab-container">
                <div class="tab-section">
                    <h2>Trip Details</h2>
                    <div class="tab-grid-template">
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Date</span></mat-label>
                            <input matInput formControlName="date">
                        </mat-form-field>
                        <mat-form-field class="bigger-width">
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Created Date</span></mat-label>
                            <input matInput formControlName="created">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">ASN Number</span></mat-label>
                            <input matInput formControlName="asn_number">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Trip Number</span></mat-label>
                            <input matInput formControlName="trip_number">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Bill Of Lading</span></mat-label>
                            <input matInput formControlName="external_bill_of_lading">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Total Cartons</span></mat-label>
                            <input matInput formControlName="total_cartons">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Manifest No of Cartons</span></mat-label>
                            <input matInput formControlName="manifest_carton_count">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">BOL Carton Count</span></mat-label>
                            <input matInput formControlName="bol_carton_count">
                        </mat-form-field>                                                
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Reported Weight</span></mat-label>
                            <input matInput formControlName="reported_weight">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Status</span></mat-label>
                            <input matInput formControlName="status">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label><span [ngClass]="{'disabled-label': detailsForm.disabled}">Week Number</span></mat-label>
                            <input matInput formControlName="week_no">
                        </mat-form-field>
                    </div>
                </div>
                <div class="tab-section">
                    <h2>Actions</h2>
                    <div style="display: flex; flex-wrap: wrap; width: 50%; gap: 10px;">
                        <button (click)="editTripDetails()" style="width: 100%; background-color: rgb(141, 8, 8); " mat-raised-button color="primary">
                            <i style="font-size: 15px;"  class="fas fa-edit"></i>&nbsp;Edit Trip Details
                        </button>
                        <button (click)="viewFullTrip()" style="width: 100%; background-color: rgb(141, 8, 8); " mat-raised-button color="primary">
                            <i style="font-size: 15px;"  class="fas fa-eye"></i>&nbsp;View Full Trip Details
                        </button>
                        <button (click)="viewPrint()" style="width: 100%; background-color: rgb(141, 8, 8); " mat-raised-button color="primary">
                            <i style="font-size: 15px;"  class="fas fa-print"></i>&nbsp;Print Trip
                        </button>
                    </div>

                </div>
            </div>
            <!-- <div class="tab-section">
                <h2>Print Documents</h2>
                <div class="tab-grid-template">
                    <div style="align-items: center; justify-content: center;">
                        <button  mat-raised-button color="primary" (click)="printLabel('bol')">Print Bill Of Lading</button>
                    </div>
                    <div style="align-items: center; justify-content: center;">
                        <button  mat-raised-button color="primary" (click)="printLabel('packing')">Print Packing Label</button>
                    </div>
                    <div style="align-items: center; justify-content: center;">
                        <button  mat-raised-button color="primary" (click)="printLabel('pallet')">Print Pallet Label</button>
                    </div>
                    <div style="align-items: center; justify-content: center;">
                        <button  mat-raised-button color="primary" (click)="printLabel('trailer')">Print Trailer Label</button>
                    </div>
                </div>
            </div> -->
        </form>
    </mat-tab>
    <mat-tab label="Shipments">
        <ag-grid-angular style="height: 250px; margin:20px" class="ag-theme-alpine"
            [columnDefs]="shipmentColumnDefs" [rowData]="shipments" (gridReady)="onGridReady($event)"
            [defaultColDef]="defaultColDef"></ag-grid-angular>
    </mat-tab>
    <mat-tab label="Barcodes">
        <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine" [columnDefs]="barcodeColumnDefs"
            [rowData]="barcodes" (cellEditingStopped)="onCellEditingStopped($event)"
            [defaultColDef]="defaultColDef"></ag-grid-angular>
    </mat-tab>
    <mat-tab label="Pallets">
        <ag-grid-angular style="height: 270px; margin:20px" class="ag-theme-alpine" [columnDefs]="palletsColumnDefs"
            [rowData]="pallets" [defaultColDef]="defaultColDef"></ag-grid-angular>
    </mat-tab>
</mat-tab-group>